import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGarage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"garage"} maskId="square-filled-radius-0-stroke-1-IconGarage"><path fillRule="evenodd" clipRule="evenodd" d="M12 2.93494L22 8.19809V20H2V8.19809L12 2.93494ZM7 19H17V16H7V19ZM7 15H17V12H7V15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconGarage;
